import { ISettingState } from '../models/types';
import * as actionTypes from '../actionsTypes';

export const initialSettingState: ISettingState = {
    logoURL: undefined,
    backgroundURL: undefined,
    pushMessaging: false,
    pushSubscribed: 0,
}

export const setting = (state = initialSettingState, action: any) => {
    switch (action.type) {
        case actionTypes.RECEIVE_LOGO_URL:
            return {
                ...state,
                logoURL: action.payload.logoURL,
            };
        case actionTypes.RECEIVE_BACKGROUND_URL:
            return {
                ...state,
                backgroundURL: action.payload.backgroundURL,
            };
        case actionTypes.USE_PUSH_MESSAGES:
            return {
                ...state,
                pushMessaging: action.payload.uses_push,
            };
        case actionTypes.PUSH_SUBSCRIBED:
            return {
                ...state,
                pushSubscribed: action.payload.push_subscribed
            };

        default: {
            return state;
        }
    }
};

